/**
 * 是否为 /landing 落地页（含 i18n 前缀，如 /en/landing）
 * @param {string} pathnameOrAsPath pathname 或 asPath 去 query 后的路径
 */
export function isLandingPathname(pathnameOrAsPath) {
  if (!pathnameOrAsPath || typeof pathnameOrAsPath !== "string") return false;
  return /\/landing\/?$/.test(pathnameOrAsPath);
}
